import Ajax from "base/Ajax";
import FormValidator from "base/FormValidator";
import PromiseHelper from "base/PromiseHelper";
import Page from "webPage/Page";

Page.register('/elearning', () => {
    $("body").on("click", ".js-access-course", () => {
        $("body").addClass("modal-active");
        $(".js-elearning-modal").addClass("modal--active");
        return false;
    });

    let validator = FormValidator.attach($(".js-elearning-form"), {
        inputOptions: {
            operator: "your",
        },
    });

    validator.on("submit", ($form) => {
        let $btn = $form.find(":submit");
        if ($btn.is(".btn--loading")) {
            return;
        }
        $btn.addClass("btn--loading");

        $(".js-message-holder").empty();

        let data = $form.serializeJSON();

        PromiseHelper.delayed_promise(Ajax.post("hateCrime", "elearning/begin", data, Ajax.WEBSITE), 600).then(() => {
            window.location.href = "/elearning-portal/";
        }).catch((e) => {
            console.warn("Couldn't submit ELearning form", e);
            validator.handleValidationException(e);

            $(".js-message-holder").html(
                eotwJSXFactory('div', {className: "message message--no-margin"}, [
                    eotwJSXFactory('span', {className: "svg-icon message__icon", unsafeHtml: "<svg><use xlink:href=\"/includes/svg-icons.svg#threat-icon\"></use></svg>"}),
                    eotwJSXFactory('p', null, [e.message])
                ]),
            );
            $btn.removeClass("btn--loading");
        });
    });

    validator.on("input:invalid", ({input}) => {
        input.$input.parents(".form__row").first().addClass("form__row--invalid");
    }).on("input:valid", ({input}) => {
        input.$input.parents(".form__row").first().removeClass("form__row--invalid");
    });
});
